import { getProductOptions } from "@faire/retailer-visitor-shared/views/product/utils/productUtils";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ProductVariationType } from "@faire/web-api--source/indigofair/data/ProductVariationType";
import uniq from "lodash/uniq";
// The maximum number of characters that a SKU can be for it to be displayed.
// Any longer, and we will not display it.
var SKU_MAX_LENGTH = 20;
/**
 * Checks whether SKU is valid. SKU is valid if it is not undefined
 * and does not exceed the maximum character display length.
 * @param sku
 */ export var isValidSKU = function(sku) {
    var _sku_length;
    return ((_sku_length = sku === null || sku === void 0 ? void 0 : sku.length) !== null && _sku_length !== void 0 ? _sku_length : Number.POSITIVE_INFINITY) <= SKU_MAX_LENGTH;
};
/**
 * Returns whether the option's variations (except for Size) all have the same value as the ones from optionToMatch.
 * @param option
 * @param optionToMatch
 */ var openSizingOptionsHaveSameVariationValues = function(option, optionToMatch) {
    return option.variations.every(function(variation) {
        if (variation.type === ProductVariationType.SIZE) {
            return true;
        } else {
            // All the variations (for example, colour) that are common between option and optionToMatch must have the same values.
            return optionToMatch.variations.every(function(matchVariation) {
                if (matchVariation.name === variation.name && matchVariation.value !== variation.value) {
                    return false;
                }
                return true;
            });
        }
    });
};
/**
 * Returns the SKUs in the given product as a string. SKUs of lengths over the limit
 * will not be in the string. SKUs for product options that have different colors, styles, etc
 * (everything aside from Size) from those of optionToMatch will also not be in the string.
 * Each SKU is separated by a comma. Removes duplicates.
 * @param product
 * @param optionToMatch
 */ export var getOpenSizingSKUsFromProduct = function(product, optionToMatch) {
    return uniq(getProductOptions(product).filter(function(option) {
        return optionToMatch ? openSizingOptionsHaveSameVariationValues(option, optionToMatch) : null;
    }).map(function(option) {
        return isValidSKU(option.brand_code) ? option.brand_code : undefined;
    }).filter(isNotUndefined)).join(", ");
};
/**
 * Returns all the SKUs in the given OrderItem as a string. SKUs of lengths over the limit
 * will not be in the string. Each SKU is separated by a comma.
 * @param product
 */ export var getAllSKUsFromOrderItem = function(orderItem) {
    return orderItem.brand_codes.map(function(sku) {
        return isValidSKU(sku) ? sku : undefined;
    }).filter(isNotUndefined).join(", ");
};
